import { AuthConfig } from '@auth0/auth0-angular';
import { Capacitor } from '@capacitor/core';
import { environment } from '../../../environments/environment';

// Determine the redirect URI based on platform
const getRedirectUri = () => {
  if (Capacitor.isNativePlatform()) {
    // For mobile apps, use app scheme with custom callback
    const platform = Capacitor.getPlatform();
    if (platform === 'ios') {
      return 'com.kyrgz.translation://auth0/callback';
    } else if (platform === 'android') {
      return 'com.kyrgz.translation://auth0/callback';
    }
  }
  // For web, use the standard Auth0 callback URL
  const redirectUri = window.location.origin;
  console.log('🔗 Generated redirect URI:', redirectUri);
  console.log('🌐 Current origin:', window.location.origin);
  console.log('🌐 Current href:', window.location.href);
  return redirectUri;
};

const redirectUri = getRedirectUri();

// Get Auth0 config from environment, with proper fallbacks
const auth0Domain = environment.auth0?.domain || 'dev-2hjdm0qn6otliqls.us.auth0.com';
// Use production Client ID as fallback for everything now, as requested
const auth0ClientId = environment.auth0?.clientId || 'Xg3Gxsm7YIddHVkM1yohO76kADkfN4Qa';

console.log('🔧 Auth0 Config - Redirect URI:', redirectUri);
console.log('🔧 Auth0 Config - Domain:', auth0Domain);
console.log('🔧 Auth0 Config - Client ID:', auth0ClientId);
console.log('🔧 Auth0 Config - Environment:', environment.production ? 'PRODUCTION' : 'DEV');
console.log('🔧 Auth0 Config - Environment.auth0:', JSON.stringify(environment.auth0));

export const authConfig: AuthConfig = {
  domain: auth0Domain,
  clientId: auth0ClientId,
  authorizationParams: {
    redirect_uri: redirectUri,
    scope: 'openid profile email',
  },
  // Disable refresh tokens to avoid "Missing Refresh Token" error
  useRefreshTokens: false,
  // Cache location - use localStorage for Capacitor apps
  cacheLocation: 'localstorage' as const,
  // Additional options to help with callback issues
  skipRedirectCallback: false,
  httpInterceptor: {
    allowedList: [
      {
        uri: `${window.location.origin}/api/*`,
        allowAnonymous: false,
      },
      {
        uri: `${environment.apiUrl}/api/*`,
        allowAnonymous: false,
      },
    ],
  },
};
